import { render, staticRenderFns } from "./EsportsMember_legendary.vue?vue&type=template&id=4454f85c&scoped=true&"
import script from "./EsportsMember_legendary.vue?vue&type=script&lang=js&"
export * from "./EsportsMember_legendary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4454f85c",
  null
  
)

export default component.exports